import { useEffect, useMemo, useState } from 'react';

/**
 * Hook for managing metrics state to an admin view.
 * @param {*} openJobs
 * @param {*} closedJobs
 * @returns
 */
const useMetrics = ({ openJobs, closedJobs }) => {
  // open --
  const [totalOpen, setTotalOpen] = useState(Number.NaN);
  const [averageTimeOpen, setAverageTimeOpen] = useState(Number.NaN);
  // -- open

  // closed --
  const [totalClosedFilled, setTotalClosedFilled] = useState(Number.NaN);
  const [totalClosed, setTotalClosed] = useState(Number.NaN);
  const [totalFilled, setTotalFilled] = useState(Number.NaN);
  const [
    totalNumberApplicantsInterviewed,
    setTotalNumberApplicantsInterviewed,
  ] = useState(0);
  const [totalNumberApplicants, setTotalNumberApplicants] = useState(
    Number.NaN
  );
  const [averageTimeToClose, setAverageTimeToClose] = useState(Number.NaN);
  const [averageTimeToFill, setAverageTimeToFill] = useState(Number.NaN);
  const [averageNumberInterviews, setAverageNumberInterviews] = useState(
    Number.NaN
  );
  const [offerAcceptance, setOfferAcceptance] = useState(Number.NaN);
  // -- closed

  useEffect(() => {
    if (Array.isArray(openJobs) && openJobs.length) {
      const jobsLength = openJobs.length;
      const today = new Date().getTime();

      let timeOpen = 0;
      for (let i = 0; i < jobsLength; i += 1) {
        const job = openJobs[i];
        timeOpen += today - job.postingDate;
      }
      setTotalOpen(jobsLength);
      setAverageTimeOpen(timeOpen / jobsLength);
    }
  }, [openJobs]);

  useEffect(() => {
    if (Array.isArray(closedJobs) && closedJobs.length) {
      const jobsLength = closedJobs.length;

      let closed = 0;
      let filled = 0;
      let interviewed = 0;
      let applicants = 0;
      let timeToFill = 0;
      let timeToClose = 0;
      let offersMade = 0;

      for (let i = 0; i < jobsLength; i += 1) {
        const job = closedJobs[i];

        if (job.closedFilled === 'Closed') {
          closed += 1;
          timeToClose += job.closedFilledDate - job.postingDate;
        } else {
          filled += 1;
          timeToFill += job.closedFilledDate - job.postingDate;
        }
        interviewed += job.numberApplicantsInterviewed;
        applicants += job.numberApplicants;
        offersMade += job.numberOffersMade;
      }

      setTotalClosedFilled(jobsLength);
      setTotalClosed(closed);
      setTotalFilled(filled);
      setTotalNumberApplicantsInterviewed(interviewed);
      setTotalNumberApplicants(applicants);
      setAverageTimeToClose(timeToClose / closed);
      setAverageTimeToFill(timeToFill / filled);
      setAverageNumberInterviews(interviewed / (closed + filled));
      setOfferAcceptance(filled / offersMade);
    }
  }, [closedJobs, totalClosed, totalClosedFilled]);

  return useMemo(() => {
    return {
      // open --
      totalOpen,
      averageTimeOpen,
      // -- open

      // closed --
      totalClosed,
      totalFilled,
      totalClosedFilled,
      qualifiedApplicants:
        totalNumberApplicantsInterviewed / totalNumberApplicants,
      averageNumberApplicants: totalNumberApplicants / totalClosedFilled,
      averageTimeToClose,
      averageTimeToFill,
      averageNumberInterviews,
      offerAcceptance,
      // -- closed
    };
  }, [
    totalOpen,
    averageTimeOpen,
    totalNumberApplicantsInterviewed,
    totalNumberApplicants,
    totalClosed,
    totalFilled,
    totalClosedFilled,
    averageTimeToClose,
    averageTimeToFill,
    averageNumberInterviews,
    offerAcceptance,
  ]);
};

export default useMetrics;
